import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import CreatePortfolioButton from '../../components/dashboard/portfolios/CreatePortfolioButton';
import { useTranslation } from 'react-i18next';
import PortfolioFilter from '../../components/portfoliosLibrary/PortfolioFilter';
import PortfolioList from '../../components/portfoliosLibrary/PortfolioList';
import PortfolioPagination from '../../components/portfoliosLibrary/PortfolioPagination';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { setViewType } from '../../store/actions/portfolioLibrary';
import { PortfolioStatus } from '../../models/Portfolio';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../components/common/BackButton';
import PorfolioConfirmPopup from '../../components/portfoliosLibrary/PorfolioConfirmPopup';

export interface IPortfoliosPageProps {
    isAddToExisting?: boolean;
}
const PortfoliosPage: React.FC<IPortfoliosPageProps> = ({ isAddToExisting }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { id, confirmSave } = useParams();
    const idAsNumber = parseInt(id as string);
    let portfolios = useAppSelector(state => state.portfolioLibrary.protfolios);
    const page = useAppSelector(state => state.portfolioLibrary.page);

    useEffect(() => {
        if (isAddToExisting) {
            if (isNaN(idAsNumber)) {
                navigate(-1);
            } else {
                dispatch(setViewType(PortfolioStatus.Draft));
            }
        } else {
            dispatch(setViewType(PortfolioStatus.Live));
        }
    }, [dispatch, idAsNumber, isAddToExisting, navigate]);

    if (isAddToExisting && portfolios !== undefined){
        portfolios = portfolios.filter(p => p.fundAllocation.filter(fa => fa.id === idAsNumber).length === 0);
    }

    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1288px"}>
            {isAddToExisting ?
                <Box display={"flex"} width={"100%"} gap={"16px"}>
                    <BackButton />
                    <Typography variant='h3'>{t('PortfolioPageTitleAddToExistingPortfolio')}</Typography>
                </Box>
                :
                <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
                    <Typography variant='h3'>{t('PortfolioPageTitle')}</Typography>
                    <Box><CreatePortfolioButton /></Box>
                </Box>
            }
            {!isAddToExisting && <PortfolioFilter />}
            <PortfolioList isAddToExisting={isAddToExisting} portfolios={portfolios} />
            <PortfolioPagination portfolios={portfolios} page={page} />
            {confirmSave !== undefined && <PorfolioConfirmPopup />}
        </Box>
    </Box>;
}

export default PortfoliosPage;